<script setup>
import axios  from "axios";
axios.defaults.withCredentials = true;
axios.defaults.crossDomain = true;

import EditorJS from '@editorjs/editorjs';
import Table from '@editorjs/table';
import ImageTool from '@editorjs/image';
import Paragraph from '@editorjs/paragraph';
import Header from '@editorjs/header';
import List from "@editorjs/list";
</script>
<template>
    <div id="simpleedit" />
</template>
<script>
export default {
    props : ["dataobj",],
    data : function(){
        return {
            editor : null,
            isready : false,
            editdata : null,
        };
    },
    watch : {
        dataobj : function(){
            if(this.editor == null || this.dataobj == null)
            {
                this.editor.clear();
                return ; 
            }
            this.editor.blocks.render({
                blocks: [{
                    type: this.dataobj.type,
                    data : this.dataobj.data,
                    id : this.dataobj.id
                }]
            });

        },
        isready : function(){
            this.editor.blocks.render({
                blocks: [{
                    type: this.dataobj.type,
                    data : this.dataobj.data
                }]
            });
        },
        editdata : function(){
            clearTimeout(this.etimeout);
            this.etimeout = setTimeout(() => {
                this.$emit("editobj",this.editdata);
            }, 500);
         },
    },
    created : function(){
        this.editor = new EditorJS({
          holder: 'simpleedit',
          tools: {
            header: {
                class :Header,
                config: {
                  placeholder: "ヘッダー",
                  levels: [2,],
                  defaultLevel: 2
                },
                inlineToolbar: false,
            },
            list: {
              class: List,
              inlineToolbar: true,
              config: {
                defaultStyle: 'unordered'
              }
            },
          image: {
            class: ImageTool,
            config: {
              actions: [],
              uploader: {
                uploadByFile(file) {
                  let formData = new FormData()
                  formData.append('image', file)
                  let config = {headers: {'content-type': 'multipart/form-data'}}
                  return axios.post('https://search.qlipper.jp/cont/', formData, config)
                    .then(res => {
                      return res.data
                    })
                },
                //only work when url has extensions like .jpg
                uploadByUrl(url) {
                  return axios.post('api/blog/fetch_file', {url: url}).then(res => {
                    return res.data
                  })
                }
              }
            }
          },
          paragraph: {
                class: Paragraph,
                inlineToolbar: true,
                config: {
                    // 空の行を許可する。
                    preserveBlank: true,
                },
            },
            table: Table,
          },
          onReady: () => {
            this.isready = true;
          },
          onChange : () => {
            this.editor.save().then((outputData) => {
                this.editdata = outputData;
            }).catch((error) => {
                console.log('Saving failed: ', error)
            });
          }
        });
    },
}
</script>
<style>
#simpleedit{
    font-size:1.7rem;
    width:93%;
    margin-left:auto;
    margin-top:20px;
}
#simpleedit li{
    margin : 0!important;
    padding: 0!important;
}
</style>
